<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-07-15 10:33:54
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-22 15:15:41
 * @FilePath: \mrc-base-server-view\src\views\mrc_system_admin\index.vue
-->
<template>
  <div>
    <div v-if="$route.name == 'mrc_system_admin'">
      <mrc_ess_table
        :headers="headers"
        :hideAddBtn="!hasBtn('add-platform-administator')"
        pageName="mrc_system_add"
        :paginationOptions="paginationOptions"
        @turnPage="getList"
        :isLoading="loading"
        :slotKey="['status', 'user_name', 'clients_uuid']"
        :items="items"
      >
        <template v-slot:search>
          <v-row
            class="d-flex justify-end"
            style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px"
          >
            <mrc_ess_advanceFilterAndSearchInput
              class="mt-4"
              v-model="systemSeniorQueryString"
              @success="getList({ cpage: 1 })"
              :systemFieldMeta="systemFieldMeta"
            ></mrc_ess_advanceFilterAndSearchInput>
          </v-row>
        </template>
        <template v-slot:item.user_name="{ item }">
          {{ INT(item.user_name) }}
        </template>
        <template v-slot:item.clients_uuid="{ item }">
          <div class="d-flex align-center">
            <!-- {{item.clients_uuid.length}} -->
            <div v-show="item.clients_uuid && item.clients_uuid.length > 0">
              <template v-for="(it, index) in splitINT(item.clients_uuid)">
                <mrc_ess_chip :key="index" small class="mr-1 my-1">
                  {{ INT(it) }}
                </mrc_ess_chip>
              </template>
            </div>
            <!-- <span>（others）</span> -->
          </div>
          <span
            v-show="!item.clients_uuid || item.clients_uuid.length <= 0"
          ></span>
        </template>
        <template v-slot:item.actions="{ item }">
          <menu-list
            :list="[
              {
                name: $t('label_View'),
                type: 'view',
                show: hasBtn('view-platform-administator'),
              },
              {
                name: $t('label_Edit'),
                type: 'edit',
                show: hasBtn('edit-platform-administator'),
              },
              {
                name: $t('label_To_reset_your_password'),
                type: 'resetPassword',
                show: hasBtn('reset-platform-administator-password'),
              },
              {
                name: item.status
                  ? $t('label_Frozen_account')
                  : $t('label_Unfreeze_the_account'),
                type: 'frozenStatus',
                show: hasBtn('platform-administator-status'),
              },
            ]"
            @handleClick="handleClick($event, item)"
          >
            <template v-slot:showAction>
              <v-icon
                v-btnAuth="[
                  'view-platform-administator',
                  'edit-platform-administator',
                  'reset-platform-administator-password',
                  'platform-administator-status',
                ]"
                >mdi-dots-vertical</v-icon
              >
            </template>
          </menu-list>
        </template>
        <template v-slot:item.status="{ item }">
          <!-- :false_view="$t('label_Frozen')" -->
          <mrc_ess_viewbtn
            :is_used="item.status_save_value"
            :label="item.status"
          >
          </mrc_ess_viewbtn>
          <!-- <span class="status"
                :class="{'is_used': !item.status}">{{item.status ? $t('label_Working') : $t('label_Frozen')}}</span> -->
        </template>
      </mrc_ess_table>
      <!-- <router-link :to='{name: "mrc_system_add"}'>新增管理员</router-link>
      <router-link :to='{name: "mrc_system_detail"}'>详情管理员</router-link> -->
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators"
import {
  mrc_admin_list,
  mrc_admin_disabled,
  mrc_admin_reset,
} from "@/service/api/mrc_system_admin"
export default {
  components: {},
  props: {},
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      loading: false,
      items: [],
      paginationOptions: {
        pagesize: this.$store.state.pageSize,
        cpage: this.$store.state.cpage,
        totalcount: 0, //总条数
        totalpage: 0, //总页数
      },
    }
  },
  validations: {},
  computed: {
    headers() {
      return [
        {
          text: this.$t("label_account"),
          value: "user_account",
        },
        {
          text: this.$t("label_Employee_name"),
          value: "user_name",
        },
        {
          text: this.$t("label_Responsible_for_the_customer"),
          value: "clients_uuid",
        },
        {
          text: this.$t("label_state"),
          value: "status",
        },
        {
          text: "",
          align: "end",
          value: "actions",
        },
      ]
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  async created() {
    await this.getBtnPermissionList()
  },
  watch: {
    async $route(val) {
      if (val.name == "mrc_system_admin") {
        await this.getList(this.paginationOptions)
        this.$store.commit("setTab", 0)
      }
    },
  },
  async mounted() {
    await this.getList(this.paginationOptions)
  },
  beforeDestroy() {},
  methods: {
    /**
     * @description: 获取列表数据
     * @param {type}
     * @return:
     * @author: lwq
     */
    async getList(obj) {
      this.loading = true
      const { cpage, pagesize } = obj

      this.paginationOptions = { ...this.paginationOptions, ...obj }
      const res = await mrc_admin_list({
        cpage: this.paginationOptions.cpage,
        pagesize: this.paginationOptions.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if ((res.code = 200)) {
        this.items = res.data
        this.paginationOptions.totalcount = res.totalcount
        this.paginationOptions.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
        this.field_alias_name = res.field_alias_name
        this.table_alias_name = res.table_alias_name
      }
      this.loading = false
    },
    /**
     * @description: 点击menulist的事件
     * @param {type}
     * @return:
     * @author: lwq
     */
    async handleClick({ item, index }, obj) {
      if (item.type == "view") {
        this.$store.commit("set_uuid", obj.uuid)
        this.$store.commit("set_subPage_name", obj.user_account)
        this.$store.commit("set_iconstatus", true)
        this.$router.push({
          name: "mrc_system_detail",
          params: {
            uuid: obj.uuid,
            name: obj.user_account,
          },
        })
      }
      if (item.type == "edit") {
        this.$store.commit("set_uuid", obj.uuid)
        this.$store.commit("set_subPage_name", obj.user_account)
        this.$store.commit("set_iconstatus", false)
        this.$router.push({
          name: "mrc_system_detail",
          params: {
            uuid: obj.uuid,
            name: obj.user_account,
          },
        })
      }
      if (item.type == "frozenStatus") {
        const disabled = await mrc_admin_disabled({
          uuid: obj.uuid,
          status: obj.status ? 0 : 1,
        })
        if (disabled.code == 200) {
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          })
          await this.getList(this.paginationOptions)
        }
      }
      if (item.type == "resetPassword") {
        this.$myConfirm({
          content: this.$t("message_Confirm_that_the_password_is_reset"),
        })
          .then(async () => {
            const reset = await mrc_admin_reset({
              uuid: obj.uuid,
              login_url: this.$store.state.loginUrl,
            })
            if (reset.code == 200) {
              this.$Message({
                text: this.$t("message_The_operation_was_successful"),
              })
              await this.getList(this.paginationOptions)
            }
          })
          .catch(() => {})
      }
    },
  },
}
</script>

<style scoped></style>
